import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Packages
import { Helmet } from 'react-helmet';

// Social helpers for facebook and twitter auth
import * as Social  from '../../../utils/social';

// Actions
import {
  initalizeOnboarding,
  updateForm,
} from '../../../actions/onboarding';

import {
  signUp,
  resetUserState
} from '../../../actions/user'

// Components
import FlashMessage from '../../../components/Global/FlashMessage';
import SignUpForm from './_modules/SignUpForm'

class SignUpDefault extends Component {
  state = {
    signUpErrorMessage: '',
    displayErrorMessages: false,
    submitting: false,
  }

  componentDidMount() {
    this.props.initalizeOnboarding();
    this.props.resetUser();
  }

  handleInputChange = (event) => {
    const { value, name } = event.target;

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: value
      }
    }), () => { this.updateFieldErrorMessage(name, value) });
  }

  handleChecklistInputChange = (name, checkboxPosition) => {
    let checklistArray = [...this.state.input[name]]

    let updatedCheckbox = {
      value: !checklistArray[checkboxPosition].value,
      label: checklistArray[checkboxPosition].label
    }

    let newState = [
      ...checklistArray.slice( 0, checkboxPosition ),
      updatedCheckbox,
      ...checklistArray.slice( checkboxPosition + 1, checklistArray.length)
    ]

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: newState
      }
    }), () => { this.updateFieldErrorMessage(name, newState) });
  }

  handleSubmit = ({ dataForSubmit, isAthlete }) => {
    const { updateOnboardingForm } = this.props

    this.setState({ submitting: true })

    let nextFormDestination = isAthlete
      ?  'athlete-info'
      : 'connect-account'

    this.props.signUp(dataForSubmit)
      .then(response => {
        if (response.success) {
          updateOnboardingForm({
            athlete_first_name: dataForSubmit.athlete_first_name,
            athlete_last_name: dataForSubmit.athlete_last_name,
            invitee_email: isAthlete ? dataForSubmit.parent_email : dataForSubmit.athlete_email
          })

          this.props.handleFormChange(nextFormDestination, 'sign-up')
        } else {
          window.scrollTo(0, 0)
          console.log('error: ', response.message)
          this.setSignUpError(response.message)
          this.setState({ submitting: false })
        }
      })
  }

  handleFacebookAuth = () => {
    Social.startFacebookAuth();
  }

  handleTwitterAuth = () => {
    Social.startTwitterAuth()
    .then((response) => {
      window.location.href = response.auth_url;
    }, (error) => {
      this.setLogInError(error);
    });
  }

  renderFormHeader() {
    const {
      invitation,
      socialAuthDenied,
    } = this.props;

    return (
      <header>
        {
          invitation &&
          <p>Curtis invited you to administer his account</p>
        }
        <h2>Sign Up for Locker Linked</h2>
        <p>
          Already have an account?&nbsp;
          <Link
            to={'/log-in'}
            className="text-link"
          >
            Log In
          </Link>
        </p>
        {socialAuthDenied &&
          <FlashMessage optionalClasses="error">
            It looks like you denied access to your {socialAuthDenied === 'facebook' ? 'Facebook' : 'Twitter'} account. Please try signing up again with Facebook, Twitter, or email.
          </FlashMessage>
        }
        <div className="social-sign-up-container">
          <a className="social-sign-up facebook" onClick={this.handleFacebookAuth}>
            <svg><use xlinkHref="#facebook"/></svg>
            <span>Use Facebook</span>
          </a>
          <a className="social-sign-up twitter" onClick={this.handleTwitterAuth}>
            <svg><use xlinkHref="#twitter"/></svg>
            <span>Use Twitter</span>
          </a>
        </div>
      </header>
    )
  }

  setSignUpError(message) {
    this.setState({
      signUpErrorMessage: message
    });
  }

  renderSignUpErrorMessage() {
    const { signUpErrorMessage } = this.state;

    if (signUpErrorMessage === 'Email already used') {
      return (
        <FlashMessage optionalClasses='error'>
          <p>
            The email you entered has already been used.
          </p>
          <p>
            <Link to="/log-in" className="text-link">Try logging in</Link> or <Link to="/" className="text-link">reset your password</Link>
          </p>
        </FlashMessage>
      )
    } else {
      return signUpErrorMessage.length > 0
      ? (
        <FlashMessage optionalClasses='error'>
          {signUpErrorMessage}
        </FlashMessage>
      )
      : ''
    }
  }

  render() {
    const { appName } = this.props;
    const { submitting } = this.state;

    return (
      <div>
        <Helmet>
          <title>{appName} | Sign Up</title>
        </Helmet>
        {this.renderFormHeader()}
        {this.renderSignUpErrorMessage()}
        <SignUpForm
          onSubmit={this.handleSubmit}
          submitting={submitting}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    onboarding: state.onboarding
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    signUp: (user) => dispatch(signUp(user)),
    resetUser: () => dispatch(resetUserState()),
    initalizeOnboarding: formData => dispatch(initalizeOnboarding(formData)),
    updateOnboardingForm: formData => dispatch(updateForm(formData)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpDefault)



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Forms/SignUpDefault.js